export const LOGIN_PATH = 'login'
export const PASSWORD_RESET_PATH = 'password-reset'
export const PASSWORD_FORGET_PATH = 'forgot-password'
export const UNSUBSCRIBE_PATH = 'unsubscribe'
